skrilla.controller('userDetailsCtrl', function ($scope, searchService, $stateParams, adminService) {
    $scope.key = "userDetails";
    $scope.hasRole = adminService.hasRole;
    $scope.tabs = [
        {title: "Summary", active: true},
        {title: "User Betting Statistics", active: false},
        {title: "Details", active: false},
        {title: "Notes", active: false},
        {title: "External Wallets", active: false},
        {title: "Limits", active: false},
        {title: "Promotions", active: false},
        {title: "Accounts", active: false},
        {title: "Pickems Entries", active: false},
        {title: "Bets", active: false},
        {title: "Communications", active: false},
        {title: "Logs", active: false},
        {title: "Contest Entries", active: false},
        {title: "Associated With", active: false},
        {title: "Exclusions", active: false},
        {title: "Verification", active: false},
        {title: "Activity Statements", active: false},
    ];

    $scope.getUser = function(){
        searchService.get('users/' + $stateParams.id + '/summary').then(function(response){
            $scope.user = response.data.user;
            $scope.summary = response.data;
        });
    }
    $scope.getUser();
    $scope.showDetailsFn = function(){
        $scope.showDetails = true;
    }

    $scope.selectedChanged = function(index){
        $scope.tabs[index].initialised = true;
    }

});

